<template>
  <div class="createOrder">
    <div class="title">选择下单科室</div>
    <div class="organization">
      <div v-if="organizationsLoading" class="organization-status">正在加载科室…</div>
      <div
        v-else-if="!organizationsFailed && !organizationList.length"
        class="organization-status"
      >
        暂无可选科室
      </div>
      <div
        v-else
        class="organization-list"
        role="group"
        aria-label="选择下单科室"
      >
        <button
          v-for="item in organizationList"
          :key="item.id"
          type="button"
          class="organization-card"
          :class="{ sel: organizationId === item.id }"
          :aria-pressed="organizationId === item.id"
          @click="organizationId = item.id"
        >
          <span class="organization-row">
            <span class="organization-label">科室：</span>{{ item.departmentLabel }}
          </span>
          <span class="organization-row">
            <span class="organization-label">医院：</span>{{ item.path[0].name }}
          </span>
        </button>
      </div>
      <el-button
        v-if="organizationsFailed"
        type="text"
        @click="getOrganizations"
      >
        加载失败，点击重试
      </el-button>
    </div>
    <div class="title">选择收货地址</div>
    <div class="address">
      <div
        class="item"
        v-for="(item, index) in addressList"
        :key="index"
        :class="id === item.id ? 'sel' : ''"
        @click="changeAddress(item)"
      >
        <div><span>收货人：</span>{{ item.mdbcej4opshigmrs }}</div>
        <div><span>联系方式：</span>{{ item.xejhteu0ub3fd3eh }}</div>
        <div>
          <span>收货地址：</span>
          {{ item.b3ccmzbfyzlwy9sc.map((el) => el.value).join('') }}
          {{ item['9simp0sjii9s0m33'] }}
        </div>
      </div>
      <div class="item add" @click="showDialogVisible">
        <img src="../../assets/img/add.png" alt="" />
      </div>
    </div>
    <div class="title">商品清单</div>
    <div class="cartTableHeader">
      <span>商品信息</span>
      <span>单价</span>
      <span>单位</span>
      <span>数量</span>
      <span>合计</span>
    </div>
    <ul class="orderList">
      <li v-for="item in commodityList" :key="'order' + item.id">
        <div class="orderDetail" v-if="form === 'cart'">
          <img
            :src="
              item['gdlu2l0z6a7sprky'] && item['gdlu2l0z6a7sprky'].length > 0
                ? item['gdlu2l0z6a7sprky'][0].url
                : ''
            "
            alt="商品图片"
          />
          <div class="goodsName">
            <p
              v-if="
                item['duovdnoapszqxeih'] && item['duovdnoapszqxeih'].length > 0
              "
            >
              {{ item['duovdnoapszqxeih'][0].value }}
            </p>
          </div>
          <span class="unitPrice">
            {{ item.qajsmihzqxevgihj ? '￥' + item.qajsmihzqxevgihj : 0 }}
          </span>
          <span class="unitPrice">
            {{ item.ycqgzdztcyhqnczy }}
          </span>
          <span class="num">
            {{ item.tbdn8rpen3ijbiv2 }}
          </span>
          <span class="num">
            {{ '￥' + item.tbdn8rpen3ijbiv2 * item.qajsmihzqxevgihj }}
          </span>
        </div>
        <div class="orderDetail" v-else-if="form === 'regularPurchaseList'">
          <img
            :src="
              item['mnkt8dkjryhvdej3'] && item['mnkt8dkjryhvdej3'].length > 0
                ? item['mnkt8dkjryhvdej3'][0].url
                : ''
            "
            alt="商品图片"
          />
          <div class="goodsName">
            <p
              v-if="
                item['whfmbyuc1i2pavi4'] && item['whfmbyuc1i2pavi4'].length > 0
              "
            >
              {{ item['whfmbyuc1i2pavi4'][0].value }}
            </p>
          </div>
          <span class="unitPrice">
            {{ item.t9rtdu9o7iztvayy ? '￥' + item.t9rtdu9o7iztvayy : 0 }}
          </span>
          <span class="num">
            {{ item.mcuilzaudpe3shlc }}
          </span>
          <span class="num">
            {{ item.kq1qbbk7dulmlghs }}
          </span>
          <span class="num">
            {{ '￥' + item.t9rtdu9o7iztvayy * (item.mcuilzaudpe3shlc || 1) }}
          </span>
        </div>
        <div class="orderDetail" v-else>
          <img
            :src="
              item['in7kxcfnzrfwav2r'] && item['in7kxcfnzrfwav2r'].length > 0
                ? item['in7kxcfnzrfwav2r'][0].url
                : ''
            "
            alt="商品图片"
          />
          <div class="goodsName">
            <p
              v-if="
                item['6qujfllbbkwsj6t1'] && item['6qujfllbbkwsj6t1'].length > 0
              "
            >
              {{ item['6qujfllbbkwsj6t1'][0].value }}
            </p>
          </div>
          <span class="unitPrice">
            {{ item.f93blbqlvdtdt65v ? '￥' + item.f93blbqlvdtdt65v : 0 }}
          </span>
          <span class="unitPrice">
            {{ item.y8cegh2yyvvqbzwo }}
          </span>
          <span class="num">
            {{ number }}
          </span>
          <span class="num">
            {{ '￥' + number * item.f93blbqlvdtdt65v }}
          </span>
        </div>
      </li>
    </ul>
    <div class="total">
      合计 ：<span>￥{{ pay_amount }}</span>
    </div>
    <div class="title">客户备注</div>
    <el-input
      type="textarea"
      placeholder="请输入内容"
      v-model="remark"
      :autosize="{ minRows: 2, maxRows: 4 }"
    >
    </el-input>
    <div class="footer">
      <el-button class="wechatPay" @click="handleWechatPay">微信支付</el-button>
      <el-button type="primary" @click="createAnOrder">提交订单</el-button>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="478px"
      :show-close="false"
    >
      <el-form ref="form" :model="address" label-width="80px">
        <el-form-item label="工号" required>
          <el-input
            v-model="address['3ulvzh2pgygl0vga']"
            placeholder="请输入工号"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人" required>
          <el-input
            v-model="address.mdbcej4opshigmrs"
            placeholder="请输入联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" required>
          <el-input
            v-model="address.xejhteu0ub3fd3eh"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="所在地区" required>
          <el-cascader
            v-model="address.b3ccmzbfyzlwy9sc"
            :options="city"
            :props="props"
            placeholder="请选择省市区"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" required>
          <el-input
            placeholder="请输入详细地址"
            v-model="address['9simp0sjii9s0m33']"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="addAddress()">确定</el-button>
      </span>
    </el-dialog>
    <wxPay ref="wxPay" @wxPaySuccess="submitAnOrder" :pay_amount="pay_amount" />
  </div>
</template>

<script>
import {
  online,
  relationFieldButtonExc,
  postOnline,
  departments,
} from "@/api/platform";
import city from "@/util/city";
import wxPay from "@/components/wxPay.vue";
import Big from "big.js";
export default {
  data () {
    return {
      form: "",
      organizationId: "",
      organizationList: [],
      organizationsLoading: false,
      organizationsFailed: false,
      addressList: [],
      id: "",
      remark: "",
      dialogVisible: false,
      address: {},
      city,
      props: {
        label: "name",
        value: "id",
      },
    };
  },
  components: {
    wxPay,
  },
  created () {
    this.form = this.$route.query.form;
  },
  computed: {
    organizationFields () {
      if (this.form === "cart") {
        return {
          uuid: "54a18789655a4e21b4012c1bd5cc1f49",
          department: "bxnagkndrgpdjpor",
          hospital: "svwuksfdbophogse",
        };
      }
      if (this.form === "regularPurchaseList") {
        return {
          uuid: "ee85e15782bf4d018ffbcf7edffb9f56",
          department: "bnjpfswlvbscxili",
          hospital: "otaqrpogcyeaupjr",
        };
      }
      return {
        uuid: "efde996a0a59494c8840daee4f627765",
        department: "iaivwxlaiefadgvj",
        hospital: "iefsmvsmqawxcmzx",
      };
    },
    selectedOrganization () {
      return this.organizationList.find(
        (item) => item.id === this.organizationId
      );
    },
    hospitalPath () {
      const path = this.selectedOrganization
        ? this.selectedOrganization.path
        : [];
      return path.slice(0, 1).map((node) => ({
        id: node.id,
        name: node.name,
      }));
    },
    commodityList () {
      return this.$store.state.commodityList;
    },
    number () {
      return this.$store.state.number;
    },
    pay_amount () {
      let money = 0;
      this.commodityList.forEach((el) => {
        // 购物车
        if (this.form === "cart") {
          let num = new Big(+el.tbdn8rpen3ijbiv2)
            .times(+el.qajsmihzqxevgihj)
            .toString();
          money = new Big(money).plus(+num).toString();
        } else if (this.form === "regularPurchaseList") {
          let num = new Big(+el.mcuilzaudpe3shlc)
            .times(+el.t9rtdu9o7iztvayy)
            .toString();
          money = new Big(money).plus(+num).toString();
        } else {
          let num = new Big(+this.number)
            .times(+el.f93blbqlvdtdt65v)
            .toString();
          money = new Big(money).plus(+num).toString();
        }
      });
      return +money;
    },
  },
  mounted () {
    this.getAddressList();
    this.getOrganizations();
  },
  methods: {
    async getOrganizations () {
      this.organizationsLoading = true;
      this.organizationsFailed = false;
      try {
        const { result } = await departments({
          field_uuid: this.organizationFields.uuid,
        });
        const options = [];
        const visit = (items) => {
          items.forEach((item) => {
            const ids = item.id_path_array || item.idPathArray;
            const names = item.name_path_array || item.namePathArray;
            if (
              !Array.isArray(ids) ||
              !ids.length ||
              !Array.isArray(names) ||
              ids.length !== names.length
            ) {
              throw new Error("组织路径缺失，请检查组织接口返回数据");
            }
            const path = ids.map((id, index) => ({
              id,
              name: names[index],
            }));
            if (
              path.some((node) => node.id == null || !node.name) ||
              String(path[path.length - 1].id) !== String(item.id)
            ) {
              throw new Error("组织路径无效");
            }
            options.push({
              id: item.id,
              departmentLabel:
                path.length > 1
                  ? path
                      .slice(1)
                      .map((node) => node.name)
                      .join(" / ")
                  : "医院本级",
              path,
            });
            if (Array.isArray(item.children)) {
              visit(item.children);
            }
          });
        };
        visit(Array.isArray(result) ? result : []);
        this.organizationList = options;
        const selectedOrganizationExists = options.some(
          (item) => String(item.id) === String(this.organizationId)
        );
        if (!selectedOrganizationExists) {
          this.organizationId = options.length === 1 ? options[0].id : "";
        }
      } catch (error) {
        this.organizationsFailed = true;
        this.organizationList = [];
        this.organizationId = "";
      } finally {
        this.organizationsLoading = false;
      }
    },
    showDialogVisible () {
      this.dialogVisible = true;
      this.address = {};
    },
    async addAddress () {
      const { address } = this;
      const validations = [
        { field: "3ulvzh2pgygl0vga", error: "请输入工号" },
        { field: "mdbcej4opshigmrs", error: "请输入联系人" },
        { field: "xejhteu0ub3fd3eh", error: "请输入联系电话" },
        { field: "b3ccmzbfyzlwy9sc", error: "请选择所在地区" },
        { field: "9simp0sjii9s0m33", error: "请输入详细地址" },
      ];
      for (const { field, error } of validations) {
        if (!address[field]) {
          return this.$notify.error({ title: "提示", message: error });
        }
      }
      // const phonePattern = /^1[3-9]\d{9}$/;
      // if (!phonePattern.test(address.xejhteu0ub3fd3eh)) {
      //   return this.$notify.error({ title: '提示', message: '请输入正确的手机号码' });
      // }
      await postOnline({
        ...address,
        form_head_uuid: "0f5b2fde26c04882a5d6c5c885a30a3f",
      });
      this.$notify({
        title: "提示",
        message: "新增成功",
        type: "success",
      });
      this.dialogVisible = false;
      this.getAddressList();
    },
    async getAddressList () {
      const { result } = await online({
        page: 1,
        limit: 100,
        keyword: "",
        select_option: "",
        form_head_uuid: "0f5b2fde26c04882a5d6c5c885a30a3f",
      });
      this.addressList = result;
      if (this.addressList.length > 0) {
        this.id = this.addressList[0].id;
      }
    },
    changeAddress ({ id }) {
      this.id = id;
    },
    // 微信支付
    handleWechatPay () {
      const { id } = this;
      if (
        !this.selectedOrganization ||
        !this.hospitalPath.length ||
        this.organizationsLoading
      ) {
        return this.$notify.error({
          title: "提示",
          message: "请选择下单科室",
        });
      }
      // 购物车
      if (!id) {
        return this.$notify({
          title: "提示",
          message: "请选择收货地址",
          type: "error",
        });
      }
      this.$refs.wxPay.dialogVisible = true;
    },
    // 提交订单
    createAnOrder () {
      const { id } = this;
      if (
        !this.selectedOrganization ||
        !this.hospitalPath.length ||
        this.organizationsLoading
      ) {
        return this.$notify.error({
          title: "提示",
          message: "请选择下单科室",
        });
      }
      // 购物车
      if (!id) {
        return this.$notify({
          title: "提示",
          message: "请选择收货地址",
          type: "error",
        });
      }
      this.submitAnOrder();
    },
    async submitAnOrder () {
      const { number, id, commodityList, form } = this;
      const organization = this.selectedOrganization;
      if (
        !organization ||
        !this.hospitalPath.length ||
        this.organizationsLoading
      ) {
        return this.$notify.error({
          title: "提示",
          message: "请选择下单科室",
        });
      }
      let button_uuid = "";
      let data = {};
      let form_head_uuid = "";
      if (form === "cart") {
        // 购物车
        button_uuid = "625ddf61-caae-411f-8377-e40ef0976d4f";
        data = {
          ipfqvqscdmxi9c2j: id,
          lmwc6txhr0ens39w: +new Date(),
          fdaj8h2d6vindtaa: this.remark,
        };
        form_head_uuid = "a6cf518450fb43289af179b8beb4b943";
      } else if (form === "regularPurchaseList") {
        // 常购清单
        data = {
          biclfhzhbnslrm0a: id,
          on1ursdhpyrlbgs6: +new Date(),
          s3o1qgwo7qj43gt6: this.remark,
        };
        button_uuid = "ef5e158f-4c8b-43af-a3ea-441fbed26911";
        form_head_uuid = "d8334de005c511efb0750242321230b4";
      } else {
        button_uuid = "d8119e52-097d-4bfb-8849-d50c09e7b8cf";
        form_head_uuid = "1906dfc5e0ce4e7cb7d6324b06e6d470";
        data = {
          cta4eumu8zrwzabn: number,
          q34wefmlbegp0lth: id,
          otnacdfn3mngpxl8: this.remark,
        };
      }
      data[this.organizationFields.department] = [
        organization.path.map((node) => node.id),
      ];
      data[this.organizationFields.hospital] = [
        this.hospitalPath.map((node) => node.id),
      ];
      try {
        // 按分类对商品进行分组
        const categoryMap = commodityList.reduce((map, item) => {
          let tags = []
          // 常购清单
          if (form === "regularPurchaseList") {
            tags = item.akwtnsppfazxxhpt || [];
          } else if (form === 'cart') {
            // 购物车
            tags = item.ssjszickckaymdja || [];
          } else {
            tags = item.dzornqdwofgytboq || [];
          }
          const categoryId = tags.length > 0 ? tags[0].id : "未分类";
          if (!map[categoryId]) {
            map[categoryId] = [];
          }
          map[categoryId].push(item);
          return map;
        }, {});

        // 将分组结果转换为数组格式
        const categoryGroups = Object.entries(categoryMap).map(
          ([categoryId, items]) => ({
            categoryId,
            items,
          })
        );
        // 显示加载提示
        const loadingInstance = this.$loading({
          lock: true,
          text: "正在提交订单...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        try {
          // 串行提交订单，每个分类间隔2秒
          for (let i = 0; i < categoryGroups.length; i++) {
            const group = categoryGroups[i];
            try {
              // 更新加载提示文本
              loadingInstance.text = `正在提交第 ${i + 1}/${categoryGroups.length
                } 个分类的订单...`;
              if (form === "cart") {
                data.lmwc6txhr0ens39w = +new Date();
              } else if (form === "regularPurchaseList") {
                data.on1ursdhpyrlbgs6 = +new Date();
              }
              const result = await relationFieldButtonExc({
                button_uuid,
                data,
                form_head_uuid,
                ids: group.items.map((item) => item.id),
              });
              console.log(`分类 ${group.categoryId} 订单提交成功`, result);

              // 如果不是最后一个分类，则等待2秒
              if (i < categoryGroups.length - 1) {
                await new Promise((resolve) => setTimeout(resolve, 3000));
              }
            } catch (error) {
              console.error(`分类 ${group.categoryId} 订单提交失败:`, error);
              throw error;
            }
          }

          // 关闭加载提示
          loadingInstance.close();

          // 显示成功提示
          this.$notify({
            title: "提示",
            message: "提交订单成功",
            type: "success",
          });

          // 更新购物车数量
          await this.$store.dispatch("getCartQuantity");

          // 延迟跳转到商城首页
          setTimeout(() => {
            this.$router.replace("/mall/show/index");
          }, 2000);
        } catch (error) {
          // 关闭加载提示
          loadingInstance.close();
          throw error;
        }
      } catch (error) {
        console.error("订单提交失败:", error);
        this.$notify({
          title: "错误",
          message: "提交订单失败，请重试",
          type: "error",
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import '../../assets/css/var.less';
.createOrder {
  padding: 30px 0;
  .organization {
    margin-bottom: 30px;

    .organization-list {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      grid-gap: 10px;
    }

    .organization-card {
      align-self: stretch;
      padding: 20px;
      border: 2px solid #f0f0f0;
      background: #fff;
      color: #666;
      font-family: inherit;
      font-size: 12px;
      line-height: 28px;
      text-align: left;
      white-space: normal;
      cursor: pointer;
      overflow-wrap: anywhere;

      &.sel,
      &:hover {
        border-color: @thirdColor;
      }

      &:focus-visible {
        outline: 2px solid @thirdColor;
        outline-offset: 3px;
      }
    }

    .organization-row {
      display: block;
    }

    .organization-label,
    .organization-status {
      color: #999;
    }

    @media (max-width: 900px) {
      .organization-list {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
    }

    @media (max-width: 480px) {
      .organization-list {
        grid-template-columns: 1fr;
      }
    }
  }

  .title {
    font-weight: bold;
    font-size: 14px;
    color: #333;
    margin-bottom: 15px;
    border-left: 3px solid @thirdColor;
    padding-left: 6px;
    line-height: 12px;
  }
  .address {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 10px;
    margin-bottom: 30px;
    .item {
      border: 2px solid #f0f0f0;
      padding: 20px 10px 20px 20px;
      cursor: pointer;
      div {
        display: flex;
        justify-content: flex-start;
        font-size: 12px;
        color: #666;
        line-height: 28px;
        span {
          color: #999;
          width: 60px;
          flex-shrink: 0;
          text-align: right;
          margin-right: 10px;
        }
      }
    }
    .add {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 30px;
      }
    }
    .sel {
      border: 2px solid @thirdColor;
    }
    // padding: 20px;
    // margin-bottom: 30px;

    // }
  }
  .cartTableHeader {
    width: 100%;
    height: 40px;
    background-color: #fafafa;
    border: 1px solid @borderColor;
    color: #666;
    font-size: 14px;
    line-height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
      flex-shrink: 0;
      display: inline-block;
      width: 160px;
      text-align: center;
      line-height: 40px;
      &:first-child {
        width: 558px;
      }
    }
  }
  .orderList {
    width: 100%;
    margin-bottom: 20px;
    li {
      border: 1px solid @borderColor;
      border-top: none;
      font-size: 13px;
      .orderHeader {
        background-color: #f1f1f1;
        height: 40px;
        line-height: 40px;
        padding: 0 5px;
        background: #f2f7ff;
        border: 1px solid #f0f0f0;
        .orderTime {
          font-weight: 600;
        }
        .orderId,
        .state {
          margin-left: 10px;
        }
      }
      .orderDetail {
        background: #fbfcff;
        width: 100%;
        height: 100%;
        padding: 20px 0;
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #666;
        padding-left: 10px;
        img {
          width: 80px;
          height: 80px;
          display: inline-block;
          // padding-left: 10px;
        }
        .goodsName {
          flex-shrink: 0;
          width: 468px;
          vertical-align: top;
          height: 84px;
          font-size: 14px;
          padding-left: 20px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          p {
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
          span {
            color: @fontDefaultColor;
            display: block;
            margin-top: 10px;
          }
        }
        .unitPrice,
        .num,
        .amount {
          flex-shrink: 0;
          display: inline-block;
          vertical-align: top;
          width: 160px;
          height: 85px;
          line-height: 85px;
          text-align: center;
          display: flex;
          justify-content: center;
        }
        .NumberInput {
          position: relative;
          top: 25px;
          /deep/span {
            color: #666;
          }
        }
        button {
          position: absolute;
          right: 20px;
          bottom: 40px;
          width: 70px;
          height: 30px;
          border-radius: 3px;
          background-color: @falseColor;
          color: white;
          border: none;
        }
        span {
          cursor: pointer;
          &:last-child {
            width: 160px;
            display: flex;
            justify-content: center;
            align-items: center;
            .icon {
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }
  }
  .total {
    margin-bottom: 20px;
    // text-align: right;
    font-size: 14px;
    display: flex;
    justify-content: flex-end;
    color: #333333;
    align-items: center;
    span {
      font-weight: 600;
      font-size: 18px;
      color: #e02020;
    }
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    .wechatPay {
      background: #2ba245;
      color: #fff;
      border: 0;
    }
  }
}
/deep/.el-cascader {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/client/CreateOrder.vue